import React from 'react';
import { csmCustomerContextTenantMigratedStatusResource } from '@jira/router-resources__service-desk-customer-service-customers-organizations-common/src/csmCustomerContextTenantMigratedStatusResource.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncDirectoryNav } from '@jira/navigation-apps__horizontal-nav-jsm-directory/src/index.tsx';
import { customerServiceProductsQueryResource } from '@jira/router-resources__service-desk-customer-service-products/src/customerServiceProductsQueryResource.tsx';
import type { ProductsAppLayout as ServicedeskCustomerServiceProductsType } from '@jira/spa-apps__servicedesk-customer-service-products/src/ProductsAppLayout.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskProductsRoute } from '@jira/router-routes__servicedesk-customer-service-products-routes/src/serviceDeskProductsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyServicedeskCustomerServiceProducts = lazyForPaint<
	typeof ServicedeskCustomerServiceProductsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-customer-service-products", jiraSpaEntry: "async-servicedesk-customer-service-products" */ '@jira/spa-apps__servicedesk-customer-service-products/src/ServicedeskCustomerServiceProducts.tsx'
		),
	),
);

const ServicedeskCustomerServiceProducts = () => (
	<LazyPage
		Page={LazyServicedeskCustomerServiceProducts}
		pageId="spa-apps/servicedesk/customer-service-products"
		shouldShowSpinner
	/>
);

export const serviceDeskProductsRouteEntry: Route = createEntry(serviceDeskProductsRoute, () => ({
	group: 'servicedesk',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncDirectoryNav,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		customerServiceProductsQueryResource,
		csmCustomerContextTenantMigratedStatusResource,
	],

	// eslint-disable-next-line no-restricted-syntax
	component: ServicedeskCustomerServiceProducts,
	perfMetricKey: 'jsm-customer-service-products-component-load',
	forPaint: [LazyAtlassianNavigation, LazyServicedeskCustomerServiceProducts],

	meta: {
		reporting: {
			id: APP_NAMES.CUSTOMER_SERVICE_PRODUCTS,
			packageName: toPackageName(APP_NAMES.CUSTOMER_SERVICE_PRODUCTS),
			teamName: 'boysenberry',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
